<template>
  <div style="width: 100%">
    <div v-if="loading" class="loader"></div>
    <div v-else class="content">
      <div class="flex form-input">
        <label class="label" for="name"
          ><span class="required">{{ $t("restaurant.name") }}</span></label
        >
        <a-input
          v-model="data.name"
          :placeholder="$t('restaurant.name')"
        ></a-input>
      </div>
      <div class="flex form-input">
        <label class="label" style="margin-right: 0" for="Rate"
          ><span class="required">Rate</span></label
        >
        <a-rate disabled v-model="data.rate" allow-half />
        <span class="rate-span">({{ data.rate }}/5.0)</span>
      </div>
      <div class="flex form-input">
        <label class="label" style="margin-right: 0" for="Rate"
          ><span>ManagersId</span></label
        >
        <div>
          <template v-for="tag in tags">
            <a-tag :key="tag" :closable="true" @close="() => handleClose(tag)">
              {{ tag }}
            </a-tag>
          </template>
          <a-input
            v-if="inputVisible"
            ref="input"
            type="text"
            size="small"
            :style="{ width: '78px' }"
            :value="inputValue"
            @change="handleInputChange"
            @blur="handleInputConfirm"
            @keyup.enter="handleInputConfirm"
          />
          <a-tag
            v-else
            style="background: #fff; borderstyle: dashed"
            @click="showInput"
          >
            <a-icon type="plus" /> New managerId
          </a-tag>
        </div>
      </div>
      <div class="flex form-input">
        <label class="label" for="summary "
          ><span class="required">{{ $t("restaurant.summary") }}</span></label
        >
        <a-input
          v-model="data.summary"
          :placeholder="$t('restaurant.summary')"
        ></a-input>
      </div>
      <div class="flex form-input">
        <label class="label" for="address"
          ><span class="required">Address</span></label
        >
        <a-input
          v-model="data.location.address"
          placeholder="Address"
        ></a-input>
      </div>
      <div class="flex form-input">
        <label class="label" for="address"
          ><span class="required">Location Maps</span></label
        >
        <div class="flex form-input-location">
          <a-input
            type="number"
            v-model="data.location.lat"
            placeholder="latitude (ex: 18.6737241)"
          ></a-input>
          <a-input
            type="number"
            v-model="data.location.lng"
            placeholder="longitude(ex: 105.6792595)"
          ></a-input>
        </div>
      </div>
      <div class="flex form-input">
        <label class="label" for="description"
          ><span class="required">{{
            $t("restaurant.description")
          }}</span></label
        >
        <vue-editor
          id="editor"
          v-model="data.description"
          useCustomImageHandler
          @image-added="handleImageAdded"
        ></vue-editor>
      </div>
      <div class="loader" v-if="uploading"></div>
      <div class="upload" v-else>
        <label for="img">
          <span class="btn-upload"> <a-icon type="upload" /> Upload </span>
        </label>
        <input
          type="file"
          id="img"
          name="img"
          accept="image/*"
          multiple
          @change="loadImage"
          :disabled="uploading"
        />
      </div>
      <div class="flex box-media">
        <div class="media flex" v-for="(i, index) in arrMedia" :key="index">
          <img :src="i" alt="" />
          <!-- <a-icon  type="delete" /> -->
          <a-icon @click="delete_img(index)" class="icon-delete" type="close" />
        </div>
        <!-- <div class="media" :style="`background-image: url('${i.data.link}')`" ></div> -->
      </div>
      <!-- <div class="map">
        <GoogleMap @location="update_location" :data_location="data.location" />
      </div> -->
      <div class="flex box-btn">
        <a-button class="cancel" @click="cancel" t>
          {{ $t("restaurant.cancel") }}
        </a-button>
        <a-button :loading="loadbtn" @click="save" type="primary">
          {{ $t("restaurant.save") }}
        </a-button>
      </div>
    </div>
  </div>
</template>
<script>
import { VueEditor } from "vue2-editor";
// import GoogleMap from "./map";
import api from "@/mixins/api";
import helper from "@/mixins/helper";
export default {
  components: { VueEditor },
  data() {
    return {
      tags: [],
      inputVisible: false,
      inputValue: "",
      uploading: false,
      loading: false,
      loadbtn: false,
      image: "",
      action: "creat",
      arrMedia: [],
      arrImages: [],
      data: {
        name: "",
        managersId: [],
        rate: 5.0,
        description: "",
        summary: "",
        location: {
          address: "",
          lat: 0,
          lng: 0,
        },
        images: [],
      },
    };
  },
  methods: {
    update_location(e) {
      this.location = e;
    },
    cancel() {
      if (confirm("Bạn chắc chắn muốn hủy bỏ?")) {
        this.$router.push("/restaurant");
      }
    },
    loadData() {
      try {
        this.loading = true;
        this.api("restaurant?id=" + this.$route.params.id).then((res) => {
          this.data = res;
          this.arrMedia = this.arrMedia.concat(res.images) || [];
          console.log("res", res);
          if (res.managersId) {
            this.tags = res.managersId;
          }
          this.loading = false;
        });
      } catch (error) {
        console.log("error", error);
      }
    },
    handleImageAdded: function (file, Editor, cursorLocation, resetUploader) {
      this.imgurUpload(file)
        .then((result) => {
          let url = result;
          Editor.insertEmbed(cursorLocation, "image", url);
          resetUploader();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    delete_img(e) {
      if (confirm("Bạn chắc chắn muốn xóa?")) {
        this.arrMedia.splice(e, 1);
        this.arrImages.splice(e, 1);
        if (this.data.images.length > e) {
          this.data.images.splice(e, 1);
        }
      }
    },
    uploadMedia(e) {
      return new Promise(async (resolve, reject) => {
        if (e.length > 0) {
          this.uploading = true;
          this.imgurUpload(e)
            .then((response) => {
              console.log("response", response);
              this.data.images = this.data.images.concat(response);
              resolve(true);
            })
            .catch((e) => {
              reject(false);
            })
            .finally(() => {
              this.uploading = false;
            });
        } else reject(false);
      });
    },
    async loadImage(e) {
      console.log(e.target.files.length);
      this.uploading = true;
      if (e.target.files) {
        let arrImgUrl = await this.imgMitiUpload(e.target.files);
        this.arrMedia = this.arrMedia.concat(arrImgUrl);
        this.uploading = false;
      }
    },
    async save() {
      if (
        this.data.name.trim().length == 0 ||
        this.data.summary.trim().length == 0 ||
        this.data.description.trim().length == 0 ||
        this.data.location.address.trim().length === 0
      ) {
        alert("Thông tin nhập vào chưa đầy đủ");
      } else {
        this.loadbtn = true;
        this.data.images = this.arrMedia;
        this.data.managersId = this.tags;
        this.api("restaurant", {
          data: this.data,
        }).then((res) => {
          this.loadbtn = false;
          if (res && !res.error) {
            alert("Lưu thành công");
            this.$router.push("/restaurant");
          } else alert("Lưu thất bại");
        });
      }
    },
    handleClose(removedTag) {
      const tags = this.tags.filter((tag) => tag !== removedTag);
      console.log(tags);
      this.tags = tags;
    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick(function () {
        this.$refs.input.focus();
      });
    },

    handleInputChange(e) {
      this.inputValue = e.target.value;
    },

    handleInputConfirm() {
      const inputValue = this.inputValue;
      let tags = this.tags;
      if (inputValue && tags.indexOf(inputValue) === -1) {
        tags = [...tags, inputValue];
      }
      console.log(tags);
      Object.assign(this, {
        tags,
        inputVisible: false,
        inputValue: "",
      });
    },
  },
  mounted() {
    console.log("this.$routes.param", this.$route.params.id);
    if (this.$route.params.id) {
      this.loadData();
      this.action = "update";
    }
  },
  mixins: [api, helper],
};
</script>
<style scoped>
@import "~vue2-editor/dist/vue2-editor.css";
.box-btn {
  width: 100%;
  justify-content: flex-end;
  margin-top: 30px;
}
.box-btn button {
  width: 100px;
}
.cancel {
  margin-right: 10px;
}
.rate-span {
  margin-left: 5px;
}
.content {
  padding: 0 5%;
}
.map {
  margin-top: 20px;
  width: 100%;
}
.upload {
  padding-left: 120px;
}
.form-input {
  margin: 10px 0;
}
.form-input input {
  height: 40px;
}
.form-input-location {
  width: 100%;
}
.form-input-location input {
  height: 40px;
}
.form-input-location input:first-child {
  margin-right: 5px;
}
.box-media {
  flex-wrap: wrap;
  padding-left: 120px;
}
.upload-loading {
  width: 100%;
}
.label {
  font-weight: bold;
  font-size: 14px;
  line-height: 17px;
  color: #202224;
  width: 120px;
  margin-right: 15px;
}
.media {
  height: 120px;
  justify-content: center;
  margin: 10px;
  position: relative;
}
.media img {
  height: 100%;
}
.icon-delete {
  box-shadow: 0px 5px 40px rgba(88, 108, 128, 0.1);
  position: absolute;
  top: -5px;
  right: -5px;
  cursor: pointer;
  z-index: 999;
  font-size: 14px;
  color: gray;
  background: #fff;
  border-radius: 50%;
  padding: 3px;
}
.icon-delete:hover {
  background: lightsalmon;
}
#img {
  /* display: none; */
  position: absolute;
  z-index: -999;
  right: 9999999999999;
  opacity: 0;
}
.btn-upload {
  border: 1px solid grey;
  width: 90px;
  padding: 5px 10px;
  cursor: pointer;
  border-radius: 5px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.btn-upload:hover {
  border-color: #1890ff !important;
}
.quillWrapper {
  width: 100%;
  height: 400px;
  margin-bottom: 80px;
}
</style>
<style >
.ql-container {
  background-color: #fff;
}
</style>
